/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/updateProfile.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_MY_ORGANIZATION, UPLOAD_FILE } from "../graphql";
import { VApplication } from "../../../application";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateProfileMethods extends IPluginMethodMap {
  getUpdateProfile(args: any): Promise<any>;
}

export interface UpdateProfileProps {
  name: string;
  description: string;
  email: string;
  phoneNumber: string;
  address: string;
  website: string;
}

export class UpdateProfileService implements IAgentPlugin {
  readonly methods: IUpdateProfileMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args: UpdateProfileProps) {
    console.log("args===>", pretty(args));
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let base64: any, imageType: any;
    if (args?.logo) {
      let logo = args?.logo;
      let name = logo.split(",");
      let image = name[0];
      imageType = image.split(":")[1].split(";")[0].split("/")[1];
      base64 = name[1];
    }

    try {
      if (client) {
        let _res;
        if (args?.logo) {
          _res = await client.mutate({
            mutation: UPLOAD_FILE,
            variables: {
              name: imageType,
              data: base64,
            },
            fetchPolicy: "no-cache",
          });
        }
        console.log("link logo:", _res?.data?.uploadFile);
        let res: any;
        if (_res?.data?.uploadFile) {
          res = await client.mutate({
            mutation: UPDATE_MY_ORGANIZATION,
            variables: {
              input: {
                ...args,
                logo: _res?.data?.uploadFile,
              },
            },
            fetchPolicy: "no-cache",
          });
        } else {
          res = await client.mutate({
            mutation: UPDATE_MY_ORGANIZATION,
            variables: {
              input: {
                ...args,
              },
            },
            fetchPolicy: "no-cache",
          });
        }
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
